module.exports = __webpack_public_path__ + "img/p-grey.f444e806.svg";